import React from 'react';
import { BookOpenIcon, ClipboardCheckIcon, NotebookPenIcon, PresentationIcon, RulerIcon, ListOrderedIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
const icons = [ListOrderedIcon, BookOpenIcon, NotebookPenIcon, RulerIcon, ClipboardCheckIcon, PresentationIcon];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-153" data-mp="1tefydf7a0mu1">
      <div className="mx-auto max-w-5xl" data-id="element-154" data-mp="1ydj0aqrymcxs">
        <SectionHeading id="solution-heading" title={<>
              One Complete System. <Accent data-id="element-156" data-mp="27fab2a1cx9yi">Everything Organized.</Accent>
            </>} body={<>
              <strong className="font-semibold text-brand-charcoal" data-id="element-157" data-mp="905uex478guk">Lash &amp; Brow Instructor Ready™</strong> brings
              your teaching resources together in one professional digital collection.
            </>} data-id="element-155" data-mp="1ygf1qp30njqz" />

        <ul className="mt-14 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-158" data-mp="nzvyrwan230">
          {solutionBenefits.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="flex items-start gap-4" data-id="element-159" data-mp="3n2avws9hz3w6" data-mpi={index}>
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full" style={{
              backgroundColor: benefit.tint
            }} data-id="element-160" data-mp="3i49dm9jwb8lr">
                  <Icon className="h-5 w-5 text-brand-charcoal" strokeWidth={1.5} aria-hidden="true" data-id="element-161" data-mp="enj43kp3udfb" />
                </span>
                <span data-id="element-162" data-mp="9la9yl0hx5bm">
                  <span className="block font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal" data-id="element-163" data-mp="4o20d8tey9lz">
                    {benefit.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-164" data-mp="2uend9irsenc6">
                    {benefit.text}
                  </span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}